<template>
    <div :class="{ header: true }">
        <!-- DESKTOP -->
        <template>
            <div class="header__container --desktop container" ref="headerRef">
                <!-- LEFT -->
                <div class="header__left">
                    <NuxtLink :to="localePath('/')" class="header__left__logo">
                        <!-- TEMPORARY -->
                        <NuxtImg
                            v-if="
                                getCurrentTheme === 'light-theme' &&
                                globalSettings?.logo?.mobileLogoLight &&
                                isUnderOrEqualViewport768
                            "
                            :src="globalSettings?.logo?.mobileLogoLight"
                            :alt="'logo'"
                        />
                        <NuxtImg
                            v-else-if="
                                getCurrentTheme === 'dark-theme' &&
                                globalSettings?.logo?.mobileLogoDark &&
                                isUnderOrEqualViewport768
                            "
                            :src="globalSettings?.logo?.mobileLogoDark"
                            :alt="'logo'"
                        />
                        <!-- TEMPORARY -->
                        <NuxtImg
                            v-else-if="
                                getCurrentTheme === 'light-theme' && globalSettings?.logo?.logoLight && !isUnderOrEqualViewport768
                            "
                            :src="globalSettings?.logo?.logoLight"
                            :alt="'logo'"
                        />
                        <NuxtImg
                            v-else-if="
                                getCurrentTheme === 'dark-theme' && globalSettings?.logo?.logoDark && !isUnderOrEqualViewport768
                            "
                            :src="globalSettings?.logo?.logoDark"
                            :alt="'logo'"
                        />
                    </NuxtLink>
                </div>

                <!-- CENTER -->
                <div class="header__center">
                    <div class="header__center__category" v-if="!isOpenInput">
                        <button
                            v-for="(category, idx) in categories"
                            v-if="category?.subcategories?.length"
                            @click="showCategory(category.id, idx)"
                            type="button"
                        >
                            <a :class="{ active: isActiveCategory(category.id) || activeCategory === category.id }">{{
                                category.categoryTitle
                            }}</a>
                            <svg :class="{ active: isActiveCategory(category.id) }">
                                <use :xlink:href="iconLink('arrowRight')"></use>
                            </svg>
                        </button>
                        <Link
                            class="header__center__category__link"
                            v-else
                            :to="localePath({ path: `/${category.categoryUrl}` })"
                            :title="category.categoryTitle"
                            @on-click="handler"
                        />
                    </div>

                    <SearchBar
                        v-model="searchValue"
                        :setDisplayInput="setDisplayInput"
                        :isOpenInput="isOpenInput"
                        @focus="toggleSearchWindowByValue(searchValue)"
                    />
                    <SearchWindow
                        :isOpen="isSearchWindowActive"
                        :isLoading="isPreloaderSearchLoading"
                        :products="searchResultProducts"
                        :categories="searchResultCategories"
                    />
                </div>

                <!-- RIGHT -->
                <div v-if="isEcaterix" class="header__right">
                    <MyActionBtn
                        class="header__right__button"
                        :btnText="$t('becomeAPartner')"
                        :urlPath="localePath('/partners')"
                        :type="'text'"
                        :size="'small'"
                    />
                    <a :href="`https://online.ecaterix.md/${$i18n.locale}`" type="button" target="_blank">
                        <svg><use :xlink:href="iconLink('person')"></use></svg>
                        <span>{{ $t('personalCabinet') }}</span>
                    </a>
                </div>

                <div
                    v-if="isShowCategory"
                    class="header__category-window"
                    v-click-outside="
                        () => {
                            this.closeCategoryMenu();
                        }
                    "
                >
                    <Link
                        v-for="link in categories[isShowCategory.idx].subcategories"
                        :key="link.id"
                        :to="localePath({ path: `/${link.subCategoryUrl}` })"
                        :title="link.subCategoryTitle"
                    />
                </div>
            </div>

            <!-- CATALOG WINDOW -->
            <CatalogWindow :isOpen="isCatalogWindowActive" :categories="parentCategories" />

            <!-- BG -->
            <div
                v-if="isShowCategory"
                class="header__background"
                :style="{ transform: `translateY(${headerHeight}px)` }"
                @click="setActiveWindow(null)"
            ></div>
        </template>
        <!-- MOBILE -->
        <div class="header__container --mobile container">
            <div class="header__left">
                <NuxtLink :to="localePath('/')" class="header__left__logo">
                    <!-- TEMPORARY -->
                    <NuxtImg
                        v-if="getCurrentTheme === 'light-theme' && globalSettings?.logo?.logoLight"
                        :src="globalSettings?.logo?.logoLight"
                        :alt="'logo'"
                    />
                    <NuxtImg
                        v-else-if="getCurrentTheme === 'dark-theme' && globalSettings?.logo?.logoDark"
                        :src="globalSettings?.logo?.logoDark"
                        :alt="'logo'"
                    />
                </NuxtLink>
            </div>

            <!-- LANGUAGE PANEL -->
            <div v-if="isLanguagePanelActive" class="header__language-panel">
                <div class="header__language-panel__langs">
                    <NuxtLink
                        prefetch
                        v-for="locale in $i18n.locales"
                        :key="locale.code"
                        :to="switchLocalePath(locale.code)"
                        :class="{
                            'header__language-panel__langs__item': true,
                            current: locale.code === $i18n.locale
                        }"
                    >
                        {{ locale.name }}
                    </NuxtLink>
                </div>
            </div>

            <!-- MOBILE -->
            <transition name="slide-fade">
                <div v-if="isUnderOrEqualViewport1024">
                    <div v-if="isShowMobileSearch" class="header__search">
                        <svg><use :xlink:href="iconLink('mobileSearch')"></use></svg>
                        <input
                            v-model="searchValue"
                            :placeholder="$t('searchMobilePlaceholder')"
                            @focus="toggleSearchWindowByValue(searchValue)"
                        />
                        <button @click="closeMobileSearch">
                            <svg><use :xlink:href="iconLink('close')"></use></svg>
                        </button>
                    </div>

                    <SearchWindow
                        :isOpen="isSearchWindowActive"
                        :isLoading="isPreloaderSearchLoading"
                        :products="searchResultProducts"
                        :categories="searchResultCategories"
                    />
                </div>
            </transition>

            <div class="header__right">
                <div class="header__right__btns">
                    <MyActionBtn
                        class="header__right__btns__search"
                        :theme="'transparent'"
                        :size="'small'"
                        :type="'icon'"
                        :icon="'search'"
                        @click="isShowMobileSearch = !isShowMobileSearch"
                    />
                    <button @click="openMobileMenu" class="header__right__btns__item" type="button">
                        <svg><use :xlink:href="iconLink('mobileMenu')"></use></svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { createCategoryLink, createParentCategoryItem } from './types';
import { mapGetters } from 'vuex';
import viewport from '~/mixins/viewport';

import MyActionBtn from '~/themes/ecaterix/components/ui/MyActionBtn';
import SearchBar from './components/SearchBar';
import Link from '~/themes/ecaterix/components/ui/MyLinkBtn';

const windowNames = ['catalog', 'search'];

export default {
    name: 'Header',
    mixins: [viewport],
    data() {
        return {
            isShowMobileSearch: false,
            isShowCategory: null,
            isOpenInput: false,
            isBackgroundActive: false,
            isLanguagePanelActive: false,
            isPreloaderSearchLoading: false,
            activeCategoryIdx: null,

            searchValue: '',
            activeWindow: null,

            headerHeight: 0,
            resizeObserver: null,

            searchResultCategories: [],
            searchResultProducts: [null, null, null] // Null item's have been used to shows skeletons preloaders of product component at first
        };
    },
    components: {
        MyActionBtn,
        SearchBar,
        Link,

        SearchWindow: () => import('./components/SearchWindow'),
        CatalogWindow: () => import('./components/CatalogWindow')
    },
    computed: {
        ...mapGetters({
            mainPhoneNumber: 'global/mainPhoneNumber',
            categories: 'categories/getCategories',
            getCurrentTheme: 'global/getCurrentTheme',
            globalSettings: 'global/globalSettings',
            isEcaterix: 'global/getIsEcaterix'
        }),

        parentCategories() {
            return this.categories
                ? this.categories.map(c => {
                      return createParentCategoryItem({
                          name: c.categoryTitle,
                          route: `/${c.categoryUrl}`,
                          img: c.categoryIcon
                      });
                  })
                : [];
        },

        isSearchValueFilled() {
            return this.searchValue.trim() ? true : false;
        },
        isSearchWindowActive() {
            return this.activeWindow === 'search' ? true : false;
        },
        isCatalogWindowActive() {
            return this.activeWindow === 'catalog' ? true : false;
        },
        activeCategory() {
            return this.categories?.find(category => {
                for (let subcategory of category?.subcategories || []) {
                    if (subcategory?.subCategoryUrl === this.$route.params.pathMatch) {
                        return true;
                    }
                }
            })?.id;
        }
    },
    watch: {
        '$i18n.locale': {
            handler() {
                this.$store.dispatch('categories/fetchCategories');
            }
        },
        '$route.params': function (newVal, oldVal) {
            if (newVal?.category) return;

            this.isShowCategory = null;
        },
        searchValue(newVal, oldVal) {
            const currentValue = newVal;

            if (newVal.trim() && oldVal.trim()) this.isPreloaderSearchLoading = true;

            this.toggleSearchWindowByValue(newVal),
                setTimeout(() => {
                    if (currentValue === this.searchValue) this.fetchProductsOnSearch(newVal);
                }, 500);
        },
        $route: function (newVal, oldVal) {
            this.setIsBackgroundActive(null);
            this.setActiveWindow(null);
            this.setIsLanguagePanelActive(false);
            this.closeCategoryMenu();
            this.searchValue = '';
            this.closeMobileSearch();
            this.isOpenInput = false;
        },
        isResetActiveCategory(newValue) {
            if (newValue) {
                this.isShowCategory = null;
            }
        }
    },
    methods: {
        closeMobileSearch() {
            this.isShowMobileSearch = false;
            this.searchValue = '';
        },
        updateHeaderHeight() {
            this.headerHeight =
                this.$refs.headerRef.clientHeight < (this.isUnderOrEqualViewport1024 ? 80 : 88)
                    ? this.isUnderOrEqualViewport1024
                        ? 80
                        : 88
                    : this.$refs.headerRef.clientHeight;
        },
        isActiveCategory(id) {
            return id === (this.isShowCategory ? this.isShowCategory.id : null);
        },
        showCategory(id, idx) {
            this.activeCategoryIdx = idx;
            this.isShowCategory = {
                id,
                idx
            };
        },
        closeCategoryMenu() {
            this.isShowCategory = null;
        },
        setDisplayInput() {
            if (!this.isOpenInput) {
                setTimeout(() => {
                    const search = document.querySelector('.search-bar input');
                    search.focus();
                }, 100);
            } else {
                this.searchValue = '';
                this.activeWindow = null;
            }
            this.isOpenInput = !this.isOpenInput;
        },
        iconLink(icon) {
            const spritePath = require('@/themes/ecaterix/assets/icons/sprite.svg');
            return `${spritePath}#${icon}`;
        },
        setIsBackgroundActive(flag) {
            this.isBackgroundActive = flag;
        },
        setActiveWindow(name) {
            if (windowNames.includes(name)) {
                this.activeWindow = name;
                this.setIsBackgroundActive(true);
            } else if (name === null) {
                this.activeWindow = null;
                this.setIsBackgroundActive(false);
            } else {
                throw new Error(`Unvalid name of window, require one of [${windowNames.join(', ')}]`);
            }
        },
        setIsLanguagePanelActive(flag) {
            this.isLanguagePanelActive = flag;
        },

        mergeParagraphs(htmlString) {
            let mergedContent = htmlString?.replace(/<\/?p[^>]*>/g, '');

            mergedContent = mergedContent?.replace(/(<\/(strong|em|b|i|u|span|a)>)/g, '$1 ');

            mergedContent = mergedContent?.replace(/(\r\n|\n|\r)/gm, '').trim();

            return `<p>${mergedContent}</p>`;
        },

        async fetchProductsOnSearch(query) {
            try {
                this.isPreloaderSearchLoading = true;
                const { data } = await this.$api.search.getSearchResults(query);

                const newProducts = data.products.map(p => {
                    return {
                        id: p?.productId,
                        img: p.img,
                        name: p.title,
                        description: p.short_description ? this.mergeParagraphs(p.short_description) : '',
                        code: p.code,
                        url: p.url
                    };
                });

                this.searchResultCategories = data.resultsByCategory.map(c => {
                    return createCategoryLink({
                        name: c.categoryTitle,
                        route: `/${c.categoryUrl}`
                    });
                });

                this.searchResultProducts = newProducts;
            } catch (error) {
                throw error('Unvalid answer of search by query end-point');
            } finally {
                this.isPreloaderSearchLoading = false;
            }
        },

        openMobileMenu() {
            this.$store.dispatch('mobile-menu/setActiveTab', 'menu');
            this.$store.dispatch('mobile-menu/setIsOpen', true);
        },
        toggleSearchWindowByValue(value) {
            if (value.trim()) this.setActiveWindow('search');
            else this.setActiveWindow(null);
        },
        handler() {
            this.isShowCategory = null;
        }
    },
    mounted() {
        this.updateHeaderHeight();
        this.resizeObserver = new ResizeObserver(this.updateHeaderHeight);

        this.resizeObserver.observe(this.$refs.headerRef);
    },
    beforeDestroy() {
        this.resizeObserver.disconnect();
    }
};
</script>

<style lang="scss" scoped>
@import './styles';
</style>
